import React, { useState, useEffect } from 'react';
import Page from '../../Common/Page';
import { Row, Col } from 'reactstrap';

import ProfileForm from './ProfileForm';
import ProgressIndicator from '../../Common/ProgressIndicator';
import ErrorIndicator from '../../Common/ErrorIndicator';

import { BALEK, MEMBER } from '../../../Data/Constants';
import { memberStateToString, roleNameToHungarian } from '../../../Utils/Converters';
import Axios from 'axios';

function ProfilePage() {
    const [isProfileLoading, setIsProfileLoading] = useState(false);
    const [isMembersLoading, setIsMembersLoading] = useState(false);
    const [profile, setProfile] = useState(null);
    const [members, setMembers] = useState([]);
    const [error, setError] = useState(false);

    useEffect(() => {
        setIsProfileLoading(true);
        Axios.get('/profile').then(res => {
            setProfile(res);
            if (res.roles && res.roles.includes(MEMBER)) {
                setIsMembersLoading(true);
                Axios.get('/users/firma').then(res => {
                    setMembers(res);
                    setIsMembersLoading(false);
                }, err => {
                    setError(true);
                    setIsMembersLoading(false);
                });
            }
            setIsProfileLoading(false);
        }, err => {
            setError(true);
            setIsProfileLoading(false);
            });
    }, []);


    if (isProfileLoading || isMembersLoading)
        return <ProgressIndicator />;

    if (error)
        return <ErrorIndicator text="A profil letöltése nem sikerült." />;

    if (profile)
        return (
            <Page centered>
                <h2>Profilom</h2>
                <Row>
                    <Col>
                        <p>
                            <strong>Név:</strong> {profile.name}<br />
                            <strong>Email cím:</strong> {profile.email}<br />
                            <strong>Első bejelentkezés időpontja:</strong> {new Date(profile.firstLoginDate).toLocaleString("hu")}<br />
                            <strong>Legutóbbi bejelentkezés időpontja:</strong> {new Date(profile.lastLoginDate).toLocaleString("hu")}<br />
                            {/*<strong>Gólya:</strong> {profile.isFreshman ? 'Igen' : 'Nem'}<br />*/}
                            <strong>Körtagság:</strong> {memberStateToString(profile.memberState)}<br />
                            {
                                profile.roles.length > 0 && <span>
                                    <strong>Jogosultságok: </strong>
                                    {profile.roles.map(r => (
                                        <span key={r}>{roleNameToHungarian(r)} </span>
                                    ))}
                                </span>
                            }
                        </p>
                        {profile.memberState >= BALEK && <ProfileForm profile={profile} members={members} />}
                    </Col>
                </Row>
            </Page>
        );

    return null;
}

export default ProfilePage;
